import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RecrewtAuthService } from '@core/services/auth/auth.service';

@UntilDestroy()
@Component({
  selector: 'recrewt-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private translate = inject(TranslateService);
  private authService = inject(RecrewtAuthService);

  constructor() {
    const translate = this.translate;

    translate.setDefaultLang('de');
  }

  ngOnInit(): void {
    if (!location.href.includes('public')) {
      this.authService.loginUser();
    }
  }
}
